import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import StorageBar from "../components/StorageBar";
import { Button } from "../components/ui/button";
import { PlusCircle, Eye, BookOpen, Lightbulb, RefreshCw, PenLine } from "lucide-react";

const PROMPTS = [
  "Qual è il ricordo d'infanzia che ti fa ancora sorridere?",
  "Che consiglio vorresti lasciare a chi ami?",
  "Racconta il giorno in cui ti sei sentito più orgoglioso di te.",
  "Descrivi un luogo che porti nel cuore e perché.",
  "Qual è la ricetta di famiglia che nessuno deve dimenticare?",
  "Scrivi una lettera a chi leggerà queste pagine tra vent'anni.",
  "Qual è la lezione più importante che la vita ti ha insegnato?",
  "Racconta come hai conosciuto la persona che ami.",
  "Qual è la canzone che racconta la tua vita? E perché?",
  "C'è qualcosa che non hai mai detto e che vorresti dire ora?",
  "Descrivi una giornata perfetta, così come la ricordi o la immagini.",
  "Qual è la tradizione che vorresti continuasse per sempre in famiglia?",
  "Un momento difficile che ti ha reso più forte: com'è andata?",
  "Che cosa ti rende orgoglioso della tua famiglia?",
];

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(() => PROMPTS[Math.floor(Math.random() * PROMPTS.length)]);

  const shuffle = () => {
    setPrompt((cur) => {
      let next = cur;
      while (next === cur) next = PROMPTS[Math.floor(Math.random() * PROMPTS.length)];
      return next;
    });
  };

  const writeThis = () => navigate("/ricordi/nuovo", { state: { prompt } });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-10 fade-in">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
          <div>
            <p className="text-sm text-primary mb-1">Ciao {user?.name?.split(" ")[0]}</p>
            <h1 className="font-serif text-4xl tracking-tight">Il tuo libro dei ricordi</h1>
            <p className="text-muted-foreground mt-2">Ogni pagina è un pezzo di te da consegnare al momento giusto.</p>
          </div>
          <div className="flex items-center gap-3">
            <Button onClick={() => navigate("/ricordi/nuovo")} className="rounded-full bg-primary hover:bg-[#c9694f] text-white h-11 px-6" data-testid="add-memory-btn">
              <PlusCircle className="w-4 h-4 mr-2" /> Aggiungi ricordo
            </Button>
          </div>
        </div>

        {/* Daily writing prompt */}
        <div className="bg-gradient-to-br from-[#FBEDE7] to-[#F7F0DA] rounded-3xl border border-[#efd9cd] p-6 sm:p-8 mb-6 relative overflow-hidden" data-testid="prompt-card">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-full bg-white/70 flex items-center justify-center">
              <Lightbulb className="w-4 h-4 text-primary" />
            </span>
            <p className="text-xs uppercase tracking-[0.15em] text-primary/80">Spunto per oggi</p>
          </div>
          <p className="font-serif text-2xl sm:text-3xl leading-snug text-[#3d2f28] max-w-2xl" data-testid="prompt-text">
            {prompt}
          </p>
          <div className="flex items-center gap-3 mt-5 flex-wrap">
            <Button onClick={writeThis} className="rounded-full bg-primary hover:bg-[#c9694f] text-white h-11 px-6" data-testid="prompt-write-btn">
              <PenLine className="w-4 h-4 mr-2" /> Scrivi questo ricordo
            </Button>
            <button onClick={shuffle} className="inline-flex items-center gap-2 text-sm text-primary hover:underline" data-testid="prompt-shuffle-btn">
              <RefreshCw className="w-4 h-4" /> Un altro spunto
            </button>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 flex-wrap mb-6">
          <Button onClick={() => navigate("/libro")} variant="outline" className="rounded-full border-border h-11 px-6" data-testid="view-book-btn">
            <BookOpen className="w-4 h-4 mr-2" /> Visualizza libro
          </Button>
          <Button onClick={() => navigate("/anteprima")} variant="outline" className="rounded-full border-border h-11 px-6" data-testid="anteprima-btn">
            <Eye className="w-4 h-4 mr-2" /> Anteprima Capsula
          </Button>
        </div>

        <StorageBar compact />
      </main>
    </div>
  );
};

export default Dashboard;
